import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import appReducer from './reducers'

function makeStore() {
  if (process.env.NODE_ENV === 'production') {
    return createStore(appReducer, applyMiddleware(thunk))
  }
  return createStore(appReducer, composeWithDevTools(applyMiddleware(thunk)))
}

const store = makeStore()

export default store



// WEBPACK FOOTER //
// ./store.js